<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">{{ $t("Current Stock Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="dropDown.selectedCinema ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3" v-if="true">
            <div class="dropdown-curve-container">
              <label :class="typeSelected ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("Type", 1) }}</label
              >

              <multiselect
                :disabled="isRoleID"
                :options="typeArray"
                v-model="typeSelected"
                :searchable="true"
                placeholder="Select Type"
                @input="onTypeSelect()"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div
            class="col-lg-6 col-xl-3 align-self-center mb-3"
            v-if="typeSelected == 'For Date'"
          >
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">✖</button>
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  :not-after="disabledAfter"
                  :disabledDates="{ from: new Date(Date.now()) }"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("select") }}
                  {{ $t("Date") }}
                </label>
              </div>
            </div>
          </div>

          <!-- 
        
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button>
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                ></Datepicker>
                <label :class="toDate ? 'active' : ''"
                  >{{ $t("show") }} {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div> -->
          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="dropdown-curve-container mr-2">
              <label
                :style="{ fontWeight: 'bold' }"
                :class="selectedLocation.sm_id ? 'shift-up ' : ''"
                >Select Location</label
              >

              <multiselect
                :disabled="isRoleID"
                :options="storeList"
                v-model="selectedLocation"
                :searchable="true"
                label="sm_store_name"
                track-by="sm_id"
                placeholder="Select location"
                @input="onSelectLocation($event)"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-3 align-self-center mb-4">
            <div class="dropdown-curve-container">
              <label :class="rm_category_id ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("category", 1) }}</label
              >
              <multiselect
                :options="rawMaterialCategories"
                v-model="selectedCategory"
                :searchable="true"
                label="rmc_category"
                track-by="rmc_id"
                placeholder=""
                @select="onSelectCategoey($event)"
                @remove="onRemoveCategory($event)"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-3 mb-4">
            <div class="dropdown-curve-container mr-2">
              <!-- <label
                :class="getDistributorReportSelectedMovie && getDistributorReportSelectedMovie.length > 0 ? 'shift-up' : ''"
              >Select Movie</label>
              <b-dropdown
                :text="getDistributorReportSelectedMovie"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(dropdownItem,dropdownIndex) in getDistributorReportMoviesList"
                  :key="dropdownIndex+dropdownItem.movie_title"
                  @click="onDistributorReportDropdownHandler({ event: $event, name:'isMovie',selectedItem: dropdownItem, index:dropdownIndex })"
                >{{ dropdownItem.movie_title }}</b-dropdown-item>
              </b-dropdown>-->
              <multiselect
                :options="Units"
                :searchable="true"
                :placeholder="filterValue.uom_unit"
                label="uom_unit"
                track-by="uom_id"
                v-model="filterValue"
                @input="searchInputData"
                :allowEmpty="false"
                :showLabels="false"
              >
              </multiselect>
            </div>
          </div>
          <div class="col-lg-4 col-xl-2 align-self-center">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input placeholder="." type="text" v-model="searchBarInput" />
                <label>{{ $t("Search") }}</label>
              </div>
              <!--Tooltip :title="$t('itemname')" /-->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('itemname')">{{
                errors.first("itemname")
              }}</span>
            </p>
          </div>

          <div
            class="col-lg-4 col-xl-2 align-self-center mb-3"
            v-if="typeSelected == 'Current Stock'"
          >
            <b-form-checkbox
              id="checkbox-1"
              class="j-checkbox pb-0"
              @change="showNegativeFn()"
              v-model="showNegative"
              name="checkbox-1"
              value="Y"
              unchecked-value="N"
            >
              Show Negative
            </b-form-checkbox>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="
                getBoxOfficeReceiptReport({ isPdf: 'N', isExcel: 'N' })
              "
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            class="col-lg-6 col-xl-12 align-self-center mb-2 d-flex justify-content-end align-items-center"
            v-if="getCurrentStockReport.length > 0"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- <a target="_blank" download title="Download as PDF">
            <img src="@/assets/img/icons/pdf-icon.svg" height="25" width="25" />
          </a> -->
            <!-- <a
            
            :href="BASE_URL + getCurrentStockReportsExcelFileName"
            target="_blank"
            title="Download as Excel"
            download
          >
            <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
          </a> -->
            <span
              @click="getBoxOfficeReceiptReport({ isPdf: 'Y' })"
              title="Download as Pdf"
            >
              <img src="@/assets/img/icons/pdf.svg" height="25" width="25" />
            </span>
            <span @click="excelDownload()" title="Download as Excel">
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </span>
          </div>
        </div>
      </div>

      <div>
        <div class="table-scroll">
          <table
            class="swc-report-table swc_table_header"
            border="1"
            id="myTable"
            v-if="getCurrentStockReport.length > 0"
          >
            <thead class="bg-lightgrey font-weight-bold">
              <th class="text-left">{{ $t("location") }}</th>
              <th>{{ $tc("rawmaterials", 1) }} Id</th>
              <th class="text-left" style="width: 300px">
                <img
                  v-if="this.columnName != 'rm_name'"
                  @click="onSortValue('rm_name', 'asc')"
                  src="@/assets/img/icons/updown.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else-if="isSort && isAscending"
                  @click="onSortValue('rm_name', 'asc')"
                  src="@/assets/img/icons/asc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                <img
                  v-else
                  @click="onSortValue('rm_name', 'desc')"
                  src="@/assets/img/icons/desc.svg"
                  class="cursor-pointer"
                  width="15px"
                  height="20px"
                />
                {{ $tc("rawmaterials", 2) }}
              </th>
              <!-- <th>{{ $t("Vendor") }} {{ $t("Name") }}</th> -->
              <template v-if="typeSelected == 'For Date'">
                <!-- <th>{{ $t("Opening") }} {{ $t("stock") }}</th>
                <th>{{ $t("Purchase") }} {{ $t("stock") }}</th>
                <th>{{ $t("Consumed") }} {{ $t("stock") }}</th> -->
                <th>{{ $t("system") }} {{ $t("stock") }}</th>
              </template>
              <template v-else>
                <th>{{ $t("system") }} {{ $t("stock") }}</th>
              </template>

              <th>{{ $t("units") }}</th>

              <th>{{ $t("rate") }}</th>
              <th>{{ $t("value") }}</th>
            </thead>
            <tbody>
              <template v-for="(stock, stockIndex) in getCurrentStockReport">
                <tr :key="stockIndex + 'row1'">
                  <td
                    :rowspan="stock.RawMaterials.length + 1"
                    class="vertical_align"
                  >
                    <span>{{ stock.sm_store_name }}</span>
                  </td>
                </tr>

                <template
                  v-for="(rawMaterial, rawMaterialIndex) in stock.RawMaterials"
                >
                  <tr :key="rawMaterialIndex + 'row-2'">
                    <td class="text-left">
                      {{ rawMaterial.rm_code }}
                    </td>
                    <td class="text-left">
                      {{ rawMaterial.rm_name }}
                    </td>
                    <template v-if="typeSelected == 'For Date'">
                      <!-- <td>{{ currFormat3(rawMaterial.opening_stock) }}</td>
                      <td>{{ currFormat3(rawMaterial.purchase) }}</td>
                      <td>
                        {{ currFormat3(rawMaterial.standard_consumption) }}
                      </td> -->
                      <td class="text-right">
                        {{ currFormat3(rawMaterial.closing_stock) }}
                      </td>
                    </template>
                    <template v-else>
                      <td class="text-right">
                        {{ currFormat3(rawMaterial.system_stock) }}
                      </td>
                    </template>
                    <td class="text-left">
                      {{ rawMaterial.uom_unit }}
                    </td>
                    <td class="text-right">
                      {{ currFormat3(parseFloat(rawMaterial.single_rate)) }}
                    </td>
                    <td class="text-right">
                      {{
                        currFormat3(
                          parseFloat(
                            rawMaterial.system_stock * rawMaterial.single_rate
                          )
                        )
                      }}
                    </td>
                  </tr>
                </template>
                <template v-if="showNegative == 'N'">
                  <tr
                    :key="rawMaterialIndex + 'grandTotal'"
                    class="bg-lightgrey font-weight-bold"
                  >
                    <td colspan="3">Total</td>
                    <td class="text-right">
                      {{
                        currFormat3(
                          stock.RawMaterials.reduce((acc, { system_stock }) => {
                            return acc + system_stock;
                          }, 0)
                        )
                      }}
                    </td>
                    <td></td>
                    <td></td>
                    <td class="text-right">
                      {{
                        currFormat3(
                          stock.RawMaterials.reduce(
                            (acc, { system_stock, single_rate }) => {
                              return acc + system_stock * single_rate;
                            },
                            0
                          )
                        )
                      }}
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>

      <table
        class="swc-report-table swc_table_header"
        border="1"
        v-if="getCurrentStockReport.length == 0"
      >
        <thead class="bg-lightgrey font-weight-bold">
          <th class="text-left">{{ $t("location") }}</th>
          <th>{{ $tc("rawmaterials", 1) }} Id</th>

          <th>{{ $tc("rawmaterials", 1) }} {{ $t("name") }}</th>
          <!-- <th>{{ $t("Vendor") }} {{ $t("Name") }}</th> -->
          <template v-if="typeSelected == 'For Date'">
            <!-- <th>{{ $t("Opening") }} {{ $t("stock") }}</th>
            <th>{{ $t("Purchase") }} {{ $t("stock") }}</th>
            <th>{{ $t("Consumed") }} {{ $t("stock") }}</th> -->

            <th>{{ $t("System") }} {{ $t("stock") }}</th>
          </template>
          <template v-else>
            <th>{{ $t("system") }} {{ $t("stock") }}</th>
          </template>

          <th>{{ $t("units") }}</th>

          <th>{{ $t("rate") }}</th>
          <th>{{ $t("value") }}</th>
        </thead>
        <tbody>
          <tr>
            <td :colspan="typeSelected == 'For Date' ? '10' : '7'">
              <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/ReportsService-v2";
  import FnBReportService from "@/services/FnBReportsService";
  import PosFnbService from "@/services/PosFnbService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import xlsx from "json-as-xlsx";
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    components: {
      NoRecords,
    },
    computed: {
      //      ...mapGetters([
      //  "getCinemasList",
      //     "getRecipeReportsSelectedCinema",
      //     "getCurrentStockReports",
      //     // EXCEL
      //     "getCurrentStockReportsExcelFileName",
      //     // PDF
      //     "getCurrentStockReportsPDFFileName"
      //   ]),
    },
    data() {
      return {
        rawMaterialCategories: [],
        rawMaterialCategoriesCopy: [],
        searchRawMaterial: "",
        selectedCategory: "",
        rm_category_id: null,

        searchBarInput: "",
        searchValue: "",
        // newSearchplaceholder:"Search",
        filterValue: {
          uom_id: "0",
          uom_unit: "All",
          uom_short_form: "All",
          name: "",
        },
        Units: [
          {
            uom_id: "0",
            uom_unit: "All",
            uom_short_form: "All",
          },
        ],
        showNegative: "Y",
        showNegativeWatchers: "Y",
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        storeList: [],
        selectedLocation: { sm_id: "" },
        fromDate: new Date(),
        toDate: new Date(),
        getBoxOfficeReport: [],
        getCurrentStockReport: [],
        getCurrentStockReportMainData: [],
        Rawmaterial: [],
        getBoxOfficeFnBReport: [],
        getPaymentArray: [],
        typeArray: ["Current Stock", "For Date"],
        typeSelected: "Current Stock",
        disabledAfter: new Date(),
        //sorting
        isSort: false,
        isAscending: false,
        columnName: "",
        orderBy: "",
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.onSelectCinema(CinemaObj);
      }

      this.getUomList();
    },
    watch: {
      "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
        if (CinemaObj) {
          this.onSelectCinema(CinemaObj);
          this.onCurrentStockDropDownHandler({
            event: null,
            name: "isCinema",
            selectedItem: CinemaObj,
          });
        }
      },
      showNegative: function(val) {
        this.getBoxOfficeReceiptReport({ isPdf: "N" });
      },
    },
    mounted() {
      let roleid = this.secureStore.get("USINFO").role_id;
      if (true) {
        this.isRoleID = false;
      }
      let cinemaId =
        this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
          ? this.secureStore.get("USINFO").cinema_id
          : null;
      this.getCinemaList(cinemaId);
      this.fetchRawMaterialCategory();
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      if (CinemaObj) {
        this.onCurrentStockDropDownHandler({
          event: null,
          name: "isCinema",
          selectedItem: CinemaObj,
        });
        this.getStockManagementData(CinemaObj.cine_id);
      }
    },

    methods: {
      fetchRawMaterialCategory() {
        let body = {
          tableName: "ms_raw_material_category",
          rmc_is_active: "Y",
        };
        MasterService.GetActiveList(body)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              this.rawMaterialCategories = data.Records;
            } else
              this.$toasted.show(data.message || "Opps! Something went wrong");
          })
          .catch((error) => {
            console.log("Error:", error);
          });
      },
      onSelectCategoey(category) {
        this.rm_category_id = category["rmc_id"];
        this.selectedCategory = category;
      },
      onRemoveCategory(cinema) {
        this.rm_category_id = null;
        this.selectedCategory = "";
      },
      onSortValue(columnName, orderBy) {
        if (!this.dropDown.selectedCinema) {
          return this.$toasted.show("Please select cinema");
        }
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderBy = orderBy;
        this.getBoxOfficeReceiptReport({ isPdf: "N" });
      },

      //   searchFilter(){
      //   let filter =document.getElementById('my_Input').value.toUpperCase();
      //   let myTable= document.getElementById('myTable');
      //   let tr = myTable.getElementsByTagName('tr');

      //   for(vari=0;i<tr.length;i++){
      //       let td = tr[i].getElementsByTagName('td')[0]
      //    if(td){
      //   let textvlaue=td.textContent || td.innerHTML;

      //   if(textvlaue.toUpperCase().indexOf(filter) > -1){
      //        tr[i].style.display="";

      //   }
      //   else
      //   {
      //      tr[i].style.display="none";
      //   }
      //  }
      //   }
      //   },
      searchInputData(event) {
        this.getBoxOfficeReceiptReport({ isPdf: "N" });
      },
      searchBarData() {
        this.getBoxOfficeReceiptReport({ isPdf: "N" });
      },
      getUomList() {
        let payload = {
          tableName: "ms_unit_of_measurement",
        };
        MasterService.GetActiveList(payload)
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              data.Records.map((x) => {
                this.Units = [...this.Units, x];
              });

              // let findIndexDta=this.Units.findIndex(z=>{
              //   return z.uom_id==0;
              // })
              // if(findIndexDta<0){
              //  this.Units=[{uom_id=0,uom_name:""},...this.Units]
              // }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(() => {
            this.$toasted.show("Error");
          });
      },
      onTypeSelect() {
        this.getCurrentStockReport = [];
      },
      onSortValue(columnName, orderBy) {
        if (!this.dropDown.selectedCinema) {
          return this.$toasted.show("Please select cinema");
        }
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderBy = orderBy;
        this.getBoxOfficeReceiptReport({ isPdf: "N" });
      },
      getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
              //  this.Cinemas.map(x => {
              //   if (String(cine_id) === String(x.cine_id)) {
              //     // let cinema = {
              //     //   cine_name: x.cine_name,
              //     //   cine_id: x.cine_id
              //     // };

              //     // this.onSelectCinema(null,cinema);

              //     // this.onCurrentStockDropDownHandler({
              //     //   name: "isCinema",
              //     //   selectedItem: {
              //     //     cine_name: x.cine_name,
              //     //     cine_id: x.cine_id
              //     //   }
              //     // });
              //   }
              // });
              // if(this.CinemasCopy.cine_name.length == 0){
              // this.$toasted.show("Select Cinema");
              // }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      showNegativeFn() {
        return;
        this.showNegativeWatchers = this.showNegative;
        this.getBoxOfficeReceiptReport({ isPdf: "N" });
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.getStockManagementData(event.cine_id);

        this.$store.dispatch("selectDropdownCinema", event);
      },
      onSelectLocation: function(event) {
        console.log("evenet=>", event);
        this.selectedLocation = event || { sm_id: "" };
      },
      getStockManagementData: function(cinema_id) {
        let payload = {
          cinema_id: cinema_id,
        };
        PosFnbService.GetStoreManagementDetails(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.Records && data.Records.length) {
              this.storeList = [...response.data.Records];
              // this.selectedLocation=this.storeList[0];
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      getBoxOfficeReceiptReport: function({ isPdf = "N" }) {
        let loader = this.$loading.show();
        this.submitted = true;
        this.getCurrentStockReport = [];
        this.getCurrentStockReportMainData = [];
        // this.getBoxOfficeFnBReport = [];
        this.getUomList();
        let isCurrentStock = true;
        if (this.typeSelected == "For Date") {
          this.showNegative = "Y";
          isCurrentStock = false;
        }

        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinema.cine_name,
          cinema_address: this.dropDown.selectedCinema.cine_address,

          searchWord: this.searchBarInput ? this.searchBarInput : "",
          rmc_id: this.rm_category_id || null,
          filterValue:
            this.filterValue.uom_unit == "All"
              ? ""
              : this.filterValue.uom_unit || "",
          // location:this.selectedLocation.sm_store_name && this.selectedLocation.sm_store_name=="ALL"?"":this.selectedLocation.sm_id,
          location: this.selectedLocation.sm_id
            ? this.selectedLocation.sm_id
            : "",

          isCurrentStock,
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          endDate: moment(this.fromDate).format("YYYY-MM-DD"),
          columnName: this.columnName,
          orderBy: this.orderBy,
          isPdf,
          showNigative: this.showNegative,
        };

        FnBReportService.GetCurrentStockReport(payload)
          .then((response) => {
            const { data } = response;
            if (data.status) {
              // console.log("data from api", data.Records);

              // this.getCurrentStockReportMainData=data.Records;
              this.getCurrentStockReport = data.Records;
              // console.log(storeArr);

              this.getCurrentStockReport.map((x) => {
                x.RawMaterials.map((y) => {
                  x["sm_store_name"] = y.sm_store_name;
                });
              });

              if (this.getCurrentStockReport && this.showNegative == "N") {
                this.getCurrentStockReport.map((x, index) => {
                  let arr = x.RawMaterials.filter((y) => {
                    return y.system_stock > 0;
                  });
                  console.log(arr, "arr_test");
                  this.getCurrentStockReport[index]["RawMaterials"] = arr;
                });
              } else {
                this.getCurrentStockReport = data.Records;
              }

              if (data.pdfPath && isPdf == "Y") {
                window.open(data.pdfPath, "_blank");
              }
              console.log(this.getCurrentStockReport, "dhcashcb");
            } else {
              this.$toasted.show(data.message);
            }
          })

          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => loader.hide(), 660);
          });
      },
      excelDownload() {
        let temp_data = this.getCurrentStockReport;

        let temp_arr = [];
        temp_data.map((x) => {
          x.RawMaterials.map((y) => {
            x["cinema_name"] = this.dropDown.selectedCinemaName;
            let obj = {
              ...x,
              ...y,
            };
            temp_arr.push(obj);
          });
        });

        let currentStock = [
          {
            value: "cinema_name",
            label: "Cinema Name",
          },
          {
            value: "sm_store_name",
            label: "Location",
          },
          {
            value: "rm_code",
            label: "Raw Material Id",
          },
          {
            value: "rm_name",
            label: "Raw Material Name",
          },
          {
            value: "system_stock",
            label: "System Stock",
          },
          {
            value: "uom_unit",
            label: "Units",
          },
          {
            value: (row) =>
              row.single_rate ? +parseFloat(row.single_rate).toFixed(3) : 0,
            label: "Rate",
          },
          {
            value: (row) =>
              row.system_stock && row.single_rate
                ? +parseFloat(row.system_stock * row.single_rate).toFixed(3)
                : 0,
            label: "Value",
          },
        ];

        // let dateWiseStock = [
        //   {
        //     value: "cinema_name",
        //     label: "Cinema Name"
        //   },
        //   {
        //     value: "sm_store_name",
        //     label: "Location"
        //   },
        //   {
        //     value: "rm_code",
        //     label: "Raw Material Id"
        //   },
        //   {
        //     value: "rm_name",
        //     label: "Raw Material Name"
        //   },

        //   {
        //     value: "opening_stock",
        //     label: "Opening Stock"
        //   },
        //   {
        //     value: "purchase",
        //     label: "Purchase Stock"
        //   },
        //   {
        //     value: "standard_consumption",
        //     label: "Consumed Stock"
        //   },
        //   {
        //     value: "system_stock",
        //     label: "Closing Stock"
        //   },
        //   {
        //     value: "uom_unit",
        //     label: "Units"
        //   },
        //   {
        //     value: row =>
        //       row.single_rate ? +parseFloat(row.single_rate).toFixed(3) : 0,
        //     label: "Rate"
        //   },
        //   {
        //     value: row =>
        //       row.system_stock && row.single_rate
        //         ? +parseFloat(row.system_stock * row.single_rate).toFixed(3)
        //         : 0,
        //     label: "Value"
        //   }
        // ];

        //console.log("comming")
        let arraynew = currentStock;
        //this.typeSelected == "For Date" ? dateWiseStock : currentStock;

        let data = [
          {
            sheet: "Current Stock Report",
            columns: arraynew,
            content: temp_arr,
          },
        ];

        let cinemaName = this.dropDown.selectedCinemaName;

        var today = new Date();
        var date =
          String(today.getDate()).padStart(2, "0") +
          "-" +
          String(today.getMonth() + 1).padStart(2, "0") +
          "-" +
          today.getFullYear();
        let settings = {
          fileName:
            this.typeSelected == "For Date"
              ? `DayWiseStock_${cinemaName}${moment(this.fromDate).format(
                  "YYYY-MM-DD"
                )}_on${date}`
              : `CurrentStockReport${cinemaName}${moment(this.fromDate).format(
                  "YYYY-MM-DD"
                )}_on${date}`,
        };
        xlsx(data, settings);
      },
    },
  };
</script>

<style scoped>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }

  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }

  .concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
  }

  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }

  .concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }

  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
  .gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
  }

  .swc-report-table {
    table-layout: auto !important;
    border: 1px solid black;
  }
  .swc-report-table th {
    border: 1px solid black !important;
  }
  .swc_table_header th {
    border: 1px solid black !important;
  }
  .vertical_align {
    vertical-align: top;
    text-align: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/currentStockReport.vue